export default  {
    component: 'live_layout',
    name: 'live_layout',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Component Order',
            param: 'component_order',
            type: 'text',
            description: `need to add device name as mentioned below in comma seperated format.
            - e.g [em,scb,inverter]
            - em
            - scb
            - inverter
            - mfm
            - ws
            - zmu`
          }
    ]
  }
